/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import { defineComponent, ref, computed, watch } from '@vue/composition-api';
import { ImageErrorIcon } from 'tdesign-icons-vue';
import { usePrefixClass } from '../../hooks/useConfig.js';
import { useDrag } from '../hooks.js';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '@babel/runtime/helpers/defineProperty';

var TImageItem = defineComponent({
  name: "TImageItem",
  props: {
    rotate: Number,
    scale: Number,
    mirror: Number,
    src: String,
    placementSrc: String
  },
  setup: function setup(props) {
    var classPrefix = usePrefixClass();
    var error = ref(false);
    var loaded = ref(false);

    var _useDrag = useDrag({
      translateX: 0,
      translateY: 0
    }),
        transform = _useDrag.transform,
        mouseDownHandler = _useDrag.mouseDownHandler;

    var imgStyle = computed(function () {
      return {
        transform: "rotate(".concat(props.rotate, "deg) scale(").concat(props.scale, ")"),
        display: !props.placementSrc || loaded.value ? "block" : "none"
      };
    });
    var placementImgStyle = computed(function () {
      return {
        transform: "rotate(".concat(props.rotate, "deg) scale(").concat(props.scale, ")"),
        display: !loaded.value ? "block" : "none"
      };
    });
    var boxStyle = computed(function () {
      var _transform$value = transform.value,
          translateX = _transform$value.translateX,
          translateY = _transform$value.translateY;
      return {
        transform: "translate(".concat(translateX, "px, ").concat(translateY, "px) scale(").concat(props.mirror, ", 1)")
      };
    });

    var resetStatus = function resetStatus() {
      error.value = false;
      loaded.value = false;
    };

    watch(function () {
      return props.src;
    }, function () {
      resetStatus();
    });
    return {
      classPrefix: classPrefix,
      boxStyle: boxStyle,
      loaded: loaded,
      error: error,
      mouseDownHandler: mouseDownHandler,
      placementImgStyle: placementImgStyle,
      imgStyle: imgStyle
    };
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__modal-pic")
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__modal-box"),
      "style": this.boxStyle
    }, [this.error && h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__img-error")
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__img-error-content")
    }, [h(ImageErrorIcon, {
      "attrs": {
        "size": "4em"
      }
    }), h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__img-error-text")
    }, ["\u56FE\u7247\u52A0\u8F7D\u5931\u8D25\uFF0C\u53EF\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D"])])]), !this.error && !!this.placementSrc && h("img", {
      "class": "".concat(this.classPrefix, "-image-viewer__modal-image"),
      "on": {
        "mousedown": function mousedown(event) {
          event.stopPropagation();

          _this.mouseDownHandler(event);
        }
      },
      "attrs": {
        "src": this.placementSrc,
        "alt": "image",
        "draggable": "false"
      },
      "style": this.placementImgStyle
    }), !this.error && h("img", {
      "class": "".concat(this.classPrefix, "-image-viewer__modal-image"),
      "on": {
        "mousedown": function mousedown(event) {
          event.stopPropagation();

          _this.mouseDownHandler(event);
        },
        "load": function load() {
          return _this.loaded = true;
        },
        "error": function error() {
          return _this.error = true;
        }
      },
      "attrs": {
        "src": this.src,
        "alt": "image",
        "draggable": "false"
      },
      "style": this.imgStyle
    })])]);
  }
});

export { TImageItem as default };
//# sourceMappingURL=ImageItem.js.map
